import { faBullseyeArrow } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { CardEmptyState, EmptyStateIcon } from 'components/atoms/empty-state';
import { useIsNativeUser } from 'hooks/use-user-type';
import { GoalModal } from './goal-modal';

const EmptyMessage = ({ projectId }) => {
  const [visible, setVisible] = useState(false);
  const onClose = () => setVisible(false);
  const isNativeUser = useIsNativeUser();

  return (
    <>
      <FormattedMessage
        id="project.overview.business_goals.empty.help_text"
        values={{ isNativeUser }}
      />{' '}
      <LinkButton onClick={() => setVisible(true)}>
        <FormattedMessage id="project.overview.business_goals.empty.cta" />
      </LinkButton>
      <GoalModal projectId={projectId} visible={visible} onClose={onClose} />
    </>
  );
};

export const EmptyContent: FC<{ projectId: number }> = ({ projectId }) => (
  <CardEmptyState
    image={<EmptyStateIcon icon={faBullseyeArrow} />}
    message={<EmptyMessage projectId={projectId} />}
  />
);
